'use client';

import React__default from 'react';
import { daysInWeekEn, daysInWeek, TODAY, FIRST_DAY, LAST_DAY } from '../../const.js';
import { useCalendar } from '../../context/calendar.js';
import { getMonth, getFullYear, getDate, getDay, handleActiveItem } from '../../utils/calendar.js';
import { MonthPanelContainer, CalendarWeekDayWrap, WeekDayLabel, CalendarGrid, CalendarItemWrap, CalendarItem } from '../../styles.css.js';
import { ECalendarType, ECalendarStyle } from '../../types.js';
import { ELanguage } from '../../../Utils/constants.js';
import Typography from '../../../Typography/index.js';
import { colors } from '../../../Colors/index.js';

function MonthPanel(_a) {
    var currentDate = _a.currentDate;
    var _b = useCalendar(), selectedDates = _b.selectedDates, handleDatesClick = _b.handleDatesClick, minDate = _b.minDate, maxDate = _b.maxDate, calendarStyle = _b.calendarStyle, pickerType = _b.pickerType, langCode = _b.langCode;
    var currentMonth = getMonth(currentDate);
    var currentYear = getFullYear(currentDate);
    var firstDayOfMonth = new Date(currentYear, currentMonth, FIRST_DAY);
    var lastDayOfMonth = new Date(currentYear, currentMonth + 1, LAST_DAY);
    var daysInMonth = getDate(lastDayOfMonth);
    var firstDayOfWeek = getDay(firstDayOfMonth);
    var handleClickItem = function (day) {
        handleDatesClick(day);
    };
    /**
     * render
     */
    // Fill the preceding days of the current month
    var calendarGrid = [];
    var _loop_1 = function (i) {
        var day = new Date(currentYear, currentMonth, -firstDayOfWeek + i + 1);
        var _c = handleActiveItem(selectedDates, day), isActiveStart = _c.isActiveStart, isActiveEnd = _c.isActiveEnd, isInRangeActive = _c.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        calendarGrid.push(React__default.createElement(CalendarItem, { type: ECalendarType.month, today: TODAY.toDateString() === day.toDateString() ? 1 : 0, key: "".concat(currentMonth - 1, "-").concat(i), active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, blur: calendarStyle === ECalendarStyle.range ? 0 : 1, visible: calendarStyle === ECalendarStyle.range ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            React__default.createElement("span", null,
                " ",
                getDate(day))));
    };
    for (var i = 0; i < firstDayOfWeek; i++) {
        _loop_1(i);
    }
    var _loop_2 = function (i) {
        var day = new Date(currentYear, currentMonth, i);
        var _d = handleActiveItem(selectedDates, day), isActiveStart = _d.isActiveStart, isActiveEnd = _d.isActiveEnd, isInRangeActive = _d.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        var isBorderStartDay = i === 1 && calendarStyle === ECalendarStyle.range;
        var isBorderEndDay = i === daysInMonth && calendarStyle === ECalendarStyle.range;
        calendarGrid.push(React__default.createElement(CalendarItem, { type: ECalendarType.month, key: "".concat(currentMonth, "-").concat(i), fullRange: selectedDates && selectedDates.length > 1 ? 1 : 0, today: TODAY.toDateString() === day.toDateString() ? 1 : 0, pickerRange: pickerType === ECalendarStyle.single ? 1 : 0, start: isActiveStart || isBorderStartDay ? 1 : 0, end: isActiveEnd || isBorderEndDay ? 1 : 0, active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            React__default.createElement("span", null,
                " ",
                i)));
    };
    // Fill the days of the current month
    for (var i = 1; i <= daysInMonth; i++) {
        _loop_2(i);
    }
    // Fill the remaining days of the calendar grid
    var lastDayOfWeek = getDay(lastDayOfMonth);
    var _loop_3 = function (i) {
        var day = new Date(currentYear, currentMonth + 1, i);
        var _e = handleActiveItem(selectedDates, day), isActiveStart = _e.isActiveStart, isActiveEnd = _e.isActiveEnd, isInRangeActive = _e.isInRangeActive;
        var isDisabled = (maxDate && day > maxDate) || (minDate && day < minDate);
        calendarGrid.push(React__default.createElement(CalendarItem, { type: ECalendarType.month, today: TODAY.toDateString() === day.toDateString() && !isInRangeActive ? 1 : 0, key: "day-".concat(daysInMonth + i), active: isActiveStart || isActiveEnd ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, blur: calendarStyle === ECalendarStyle.range ? 0 : 1, visible: calendarStyle === ECalendarStyle.range ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return handleClickItem(day); } },
            React__default.createElement("span", null,
                " ",
                day.getDate())));
    };
    for (var i = 1; i <= 6 - lastDayOfWeek; i++) {
        _loop_3(i);
    }
    return (React__default.createElement(MonthPanelContainer, null,
        React__default.createElement(CalendarWeekDayWrap, null, (langCode === ELanguage.EN ? daysInWeekEn : daysInWeek).map(function (item) { return (React__default.createElement(WeekDayLabel, { key: item },
            React__default.createElement(Typography, { color: colors.grey[20], name: 'paragraph', size: 'small' }, item))); })),
        React__default.createElement(CalendarGrid, null, calendarGrid.map(function (elm, index) { return (React__default.createElement(CalendarItemWrap, { key: index }, elm)); }))));
}

export { MonthPanel as default };
//# sourceMappingURL=monthPanel.js.map
